import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import CredentialsHelper from './components/CredentialsHelper';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/member-dashboard');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Login - Finet Manager</title>
        <meta name="description" content="Acesso seguro para administradores e equipe ao sistema de gestão de filiados." />
        <meta name="keywords" content="partido político, gestão de membros, login, acesso seguro" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-lg">
          <div className="bg-card rounded-xl shadow-deep border border-border p-8">
            {/* Login Header */}
            <LoginHeader />

            {/* Login Form */}
            <LoginForm />

            {/* Demo Credentials Helper */}
            <CredentialsHelper />

            {/* Trust Signals */}
            <TrustSignals />

            {/* Footer */}
            <div className="mt-8 pt-6 border-t border-border text-center">
              <p className="text-xs text-muted-foreground">
                © {new Date()?.getFullYear()} Finet Manager. Todos os direitos reservados.
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Para suporte técnico, contate o administrador do sistema.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;